import { render, staticRenderFns } from "./RecentContentTopic.vue?vue&type=template&id=690f1d41&scoped=true&"
import script from "./RecentContentTopic.vue?vue&type=script&lang=js&"
export * from "./RecentContentTopic.vue?vue&type=script&lang=js&"
import style0 from "./RecentContentTopic.vue?vue&type=style&index=0&id=690f1d41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f1d41",
  null
  
)

export default component.exports